<!-- <div *ngIf="!isPlural"><strong>{{this.label}}: </strong>{{ this.specificObject.name || 'N/A' }}</div> -->
<!-- <div *ngIf="isPlural"><strong>{{this.label}}:</strong> {{ this.specificObject.name +'s' || 'N/A' }}</div> -->
<!-- <div *ngIf="isPlural"><strong>{{this.label}}:</strong> {{ this.specificObject.name === 'Strawberry' ? 'Strawberries' : (this.specificObject.name + 's') || 'N/A' }}</div>
 -->
 <div *ngIf="!isPlural"><strong>{{label}}: </strong>{{ specificObject?.name || 'N/A' }}</div>
 <!-- <div *ngIf="isPlural"><strong>{{label}}: </strong>{{ getPluralizedName(specificObject?.namePlural) || 'N/A' }}</div> -->
 <div *ngIf="isPlural"><strong>{{label}}: </strong>{{ specificObject?.namePlural || 'N/A' }}</div>
 
